
import { Component, Vue, Prop } from 'vue-property-decorator'
import { addStakeRecord, getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import { pledgeRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'createPledge',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) currency!: any
  @Prop({ required: true }) balance!: any

  private pledgeForm: any = {
    id: null,
    product_account: null,
    resource: null,
    frozen_balance: null,
    address: this.balance.address,
    pledge_type: 1
  }
  private rules = pledgeRules
  private productList: any = []
  private loading: boolean = false

  private result: number | null = null

  private input (e: Number) {
    this.pledgeForm.frozen_balance = e
    if (this.pledgeForm.resource === 'energy') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_energy_weight) *
        this.balance.total_energy_limit
      this.getResults = this.getResults.toFixed(2)
    } else if (this.pledgeForm.resource === 'bandwidth') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_net_weight) *
        this.balance.total_net_limit
      this.getResults = this.getResults.toFixed(2)
    }
  }

  private getResults: any = null

  private changeResource () {
    this.getResults = null
    this.pledgeForm.frozen_balance = null
  }

  // 25%
  private twentyFive () {
    this.result = this.balance.balance * 0.25
    this.pledgeForm.frozen_balance = this.result.toFixed(6)
    if (this.pledgeForm.resource === 'energy') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_energy_weight) *
        this.balance.total_energy_limit
      this.getResults = this.getResults.toFixed(2)
    } else if (this.pledgeForm.resource === 'bandwidth') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_net_weight) *
        this.balance.total_net_limit
      this.getResults = this.getResults.toFixed(2)
    }
  }
  // 50%
  private fifty () {
    this.result = this.balance.balance * 0.5
    this.pledgeForm.frozen_balance = this.result.toFixed(6)
    if (this.pledgeForm.resource === 'energy') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_energy_weight) *
        this.balance.total_energy_limit
      this.getResults = this.getResults.toFixed(2)
    } else if (this.pledgeForm.resource === 'bandwidth') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_net_weight) *
        this.balance.total_net_limit
      this.getResults = this.getResults.toFixed(2)
    }
  }

  // 75%
  private seventyFive () {
    this.result = this.balance.balance * 0.75
    this.pledgeForm.frozen_balance = this.result.toFixed(6)
    if (this.pledgeForm.resource === 'energy') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_energy_weight) *
        this.balance.total_energy_limit
      this.getResults = this.getResults.toFixed(2)
    } else if (this.pledgeForm.resource === 'bandwidth') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_net_weight) *
        this.balance.total_net_limit
      this.getResults = this.getResults.toFixed(2)
    }
  }

  // 100%
  private hundred () {
    this.result = this.balance.balance * 1
    this.pledgeForm.frozen_balance = this.result.toFixed(6)
    if (this.pledgeForm.resource === 'energy') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_energy_weight) *
        this.balance.total_energy_limit
      this.getResults = this.getResults.toFixed(2)
    } else if (this.pledgeForm.resource === 'bandwidth') {
      this.getResults =
        (this.pledgeForm.frozen_balance / this.balance.total_net_weight) *
        this.balance.total_net_limit
      this.getResults = this.getResults.toFixed(2)
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 获取产品列表
  private async getProductLists () {
    const data: any = {
      currency: 'USDT',
      status: 1
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
    })
  }

  private changeProduct (e: any) {
    this.productAccount = []
    this.pledgeForm.product_account = null
    this.pledgeForm.resource = null
    this.pledgeForm.frozen_balance = null
    this.getProductAccount(e)
  }

  // 获取产品账户
  private productAccount: any = []
  private async getProductAccount (e) {
    const data: any = {
      product: e
    }
    await getProductAccountList(data).then((res: any) => {
      this.productAccount = res.results
    })
  }

  private back () {
    this.$emit('close')
  }

  private save () {
    (this.$refs.pledgeForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            product_account: this.pledgeForm.product_account,
            resource: this.pledgeForm.resource,
            frozen_balance: this.pledgeForm.frozen_balance,
            address: this.pledgeForm.address
          }
          await addStakeRecord(data).then(() => {
            this.$message({
              message: 'Create Successful!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  mounted () {
    this.getProductLists()
    console.log(this.balance)
  }
}
